import { FormControl, MenuItem, Typography, Select } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import { useAppState } from '../../../../state'
import Speaker from '../../../speaker'
import { useAudioOutputDevices } from '../deviceHooks/deviceHooks'

const useStyles = makeStyles({
    container: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
    },
})

export default function AudioOutputList() {
    const classes = useStyles()
    const audioOutputDevices = useAudioOutputDevices()
    const { activeSinkId, setActiveSinkId } = useAppState()
    const activeOutputLabel =
        audioOutputDevices.find(device => device.deviceId === activeSinkId) &&
        audioOutputDevices.find(device => device.deviceId === activeSinkId)
            .label //audioOutputDevices.find(device => device.deviceId === "default").label || "default";

    console.count('AudioOutputList Component')

    return (
        <div className={classes.container}>
            <div className="inputSelect">
                {audioOutputDevices.length > 1 ? (
                    <FormControl fullWidth>
                        <Typography variant="h6">Audio Output:</Typography>
                        <Select
                            onChange={e => setActiveSinkId(e.target.value)}
                            value={activeSinkId}
                        >
                            {audioOutputDevices.map(device => (
                                <MenuItem
                                    value={device.deviceId}
                                    key={device.deviceId}
                                >
                                    {device.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                ) : (
                    <>
                        <Typography variant="h6">Audio Output:</Typography>
                        <Typography>
                            {activeOutputLabel || 'System Default Audio Output'}
                        </Typography>
                    </>
                )}
            </div>
            <Speaker />
        </div>
    )
}
